@if (shouldShow) {
	<section class="cue-retry-panel" aria-label="Reintento de actividades corregidas">
		<div class="cue-retry-panel__text">
			<span class="cue-step-label">Reintento amable</span>
			<h4>Reintenta solo lo que falta</h4>
			<p>{{ description }}</p>
		</div>

		<div class="cue-retry-panel__stats" aria-label="Resumen del reintento">
			<span>✓ {{ acceptedCount }} ya aceptadas</span>
			<span>⚠ {{ problemCount }} con problemas</span>
			<span>⏳ {{ pendingReviewCount }} aún por revisar</span>
		</div>

		<div class="cue-retry-panel__actions">
			<p-button
				type="button"
				label="Reintentar actividades corregidas"
				icon="pi pi-refresh"
				severity="success"
				[outlined]="true"
				[loading]="showSpinner"
				[disabled]="!canRetry"
				(onClick)="retry()"
			></p-button>

			<p-button
				type="button"
				label="Ver aceptadas"
				icon="pi pi-check-circle"
				severity="secondary"
				[text]="true"
				[disabled]="acceptedCount === 0"
				(onClick)="requestAcceptedReview()"
			></p-button>

			<p-button
				type="button"
				label="Ver problemas"
				icon="pi pi-exclamation-triangle"
				severity="warn"
				[text]="true"
				[disabled]="problemCount === 0"
				(onClick)="requestProblemReview()"
			></p-button>
		</div>
	</section>
}
